import React, { useState, useEffect, useMemo } from 'react'
import { capitalizeAndRemoveUnderscores, limitWords, formatDateAndTime, downloadFile } from '../../utils/utils';
import { Table, Button, Tooltip, message } from "antd";
import FileTextIcon from "../../components/icons/FileTextIcon";
import EyeOutlineIcon from "../../components/icons/EyeOutlineIcon";
import RightArrowIcon from "../../components/icons/RightArrowIcon";
import { Link } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";


export default function RecentContractsAudit() {

    const [recentContracts, setRecentContracts] = useState([]);
    const [errorMessageShown, setErrorMessageShown] = useState(false);


    useEffect(() => {
        const fetchRecentContracts = async () => {
            try {
                const payload = {
                    page_size: 10,
                    page_number: 1,
                }
                const response = await axiosInstance.post(`/contract/get/`, payload)
                setRecentContracts(response.data.results);
            } catch (error) { }
        };

        fetchRecentContracts();
    }, []);


    const handleViewClick = (link, name) => {
        if (link) {
            //   downloadFile(link);
            downloadFile(link, name)
            // Reset error message state
            setErrorMessageShown(false);
        } else {
            // Show error message only if it hasn't been shown already
            if (!errorMessageShown) {
                message.error("Document does not exist.");
                setErrorMessageShown(true);
                // Automatically reset error message state after 2 seconds (5000 milliseconds)
                setTimeout(() => {
                    setErrorMessageShown(false);
                }, 2000);
            }
        }
    };

    const columns = useMemo(() => [
        {
            title: "Contract ID",
            dataIndex: "document_id",
            ellipsis: true,
            width: 160, // Wider for full heading text
            key: "document_id",
            render: (text) => <span>{text}</span>,
        },
        {
            title: "Last modified User",
            width: 160,
            ellipsis: true,
            dataIndex: "editable_username",
            render: (document, record) => (
                <span>{document && document}</span>
            ),
        },
        {
            title: "Last Modified Time",
            dataIndex: "modified_at",
            width: 160,
            ellipsis: true,
            render: (document, record) => (
                <span>{document && formatDateAndTime(document)}</span>
            ),
        },
        {
            title: "Agreement Type",
            dataIndex: "agreement_type",
            ellipsis: true,
            width: 160, // Increase width
            key: "agreement_type",
            render: (text) => (
                <span >{limitWords(text, 6)}</span>
            ),
        },
        {
            title: "Partner Name",
            dataIndex: "name_of_client",
            ellipsis: true,
            width: 160,
            key: "name_of_client",
            render: (text) => <span >{text}</span>,
        },

        {
            title: "Status",
            ellipsis: true,
            key: "status",
            width: 160,
            dataIndex: "status",
            render: (text) => capitalizeAndRemoveUnderscores(text),
        },
        {
            title: "Current Remarks",
            ellipsis: {
                showTitle: false,
            },
            width: 160,
            key: "remarks",
            dataIndex: "remarks",
            render: (text, record) => (
                <Tooltip title={text}><div>{limitWords(text, 6)} </div></Tooltip>
            ),
        },
        {
            title: "Current Version",
            dataIndex: "agreement",
            ellipsis:true,
            width: 140,
            render: (text, record) => (
                <>
                    <Button
                        onClick={() => handleViewClick(record?.contract_history?.[0]?.current_agreement, record?.document_id)}
                        type="submit"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
        {
            title: "Previous Version",
            dataIndex: "agreement",
            ellipsis:true,
            width: 140,
            render: (text, record) => (
                <>
                    <Button
                        onClick={() => handleViewClick(record?.contract_history?.[0]?.previous_agreement, record?.document_id)}
                        type="submit"
                        className="documentIcon"
                    >
                        <FileTextIcon />
                    </Button>
                </>
            ),
        },
        {
            title: "View Audit Trails",
            dataIndex: "first_name",
            ellipsis:true,
            width: 140,
            key: 'first_name'
            ,
            render: (text, record) => (
                <Link to={`/admin/contracts/${record.id}?referrer=audit-trail&tab=versionControl`}>
                    <button
                        type="submit"
                    >
                        <EyeOutlineIcon />
                    </button>
                </Link>
            ),
        },
        {
            title: "View details",
            dataIndex: "first_name",
            ellipsis: true,
            key: "first_name",
            render: (text, record) => (
                <Link
                    to={`/admin/contracts/${record.id}?referrer=dashboard&tab=details`}
                >
                    <button
                        type="submit"
                    >
                        <RightArrowIcon />
                    </button>
                </Link>
            ),
        },

    ], [recentContracts])

    return (
        <div className="flex  flex-col md:flex-row mt-5">
            <div className="w-full  mr-1 bg-white rounded-l-lg pl-2">
                <h1
                    className="pl-4 font-semibold"
                    style={{ fontSize: 20, paddingTop: "1%" }}
                >
                    Recent Contracts & Audit Trail
                </h1>
                <Table
                    dataSource={recentContracts}
                    columns={columns}
                    className="overflow-y-scroll overflow-x-scroll mt-4"
                    scroll={{ x: 1650 }}
                    pagination={false}
                    size="small"
                />
            </div>
        </div>
    )
}
